import React from "react";
import Layout from "../components/Layout";

export default function Discover() {
  return (
    <Layout>
      <div className="p-4 flex items-center justify-center h-full">
        <div className="text-xl text-gray-500">Discover page coming soon</div>
      </div>
    </Layout>
  );
}